import b1 from "../images/b1.svg";
import b2 from "../images/b2.svg";
import b3 from "../images/b3.svg";

export const data = [
  {
    image: {
      src: b1,
      w: 24,
      h: 24,
    },
    text: "Any equipment or specific knowledge is not required",
  },
  {
    image: {
      src: b2,
      w: 24,
      h: 24,
    },
    text: "Custom programs depending on the goal, available time, and current state of health",
  },
  {
    image: {
      src: b3,
      w: 24,
      h: 16,
    },
    text: "Programs created by a professional fitness trainer with 15 years of experience",
  },
];
